import React from 'react'

export type CardTypes =
  | 'visa'
  | 'mastercard'
  | 'master'
  | 'diners'
  | 'amex'
  | 'american-express'
  | 'hipercard'
  | 'discover'
  | 'aura'
  | 'banricompras'
  | 'elo'
  | 'jcb'
  | 'cabal'
  | 'credz'
  | 'maestro'

interface CreditCardIconProps {
  cardType: CardTypes
}

const CreditCardIcon: React.FC<CreditCardIconProps> = ({ cardType }) => {
  return (
    <div
      className={`rounded relative bg-black flex items-center justify-center rccs__card--${cardType.toLocaleLowerCase()}`}
    >
      <div className="rccs__issuer !w-[40px] !h-[25px] !static !bg-center"></div>
    </div>
  )
}

export default CreditCardIcon
